var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.75,
    viewBox: "0 0 18 18.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share_18px",
    transform: "translate(-1120 -511.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1129",
    "data-name": "Rectangle 1129",
    width: 18,
    height: 18,
    transform: "translate(1120 512)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3777",
    "data-name": "Group 3777"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1131 512)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1121 518)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1131 523)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3776",
    "data-name": "Group 3776",
    transform: "translate(39.205 -1.525)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    x2: 4.258,
    y2: 3.28,
    transform: "translate(1087.537 523.802)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_109",
    "data-name": "Line 109",
    x1: 4.25,
    y2: 3.28,
    transform: "translate(1087.537 518.033)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareContactIcon);
export default __webpack_public_path__ + "static/media/share-contact-icon.7f049384f2ef9a1c8348d66fdb961bc3.svg";
export { ForwardRef as ReactComponent };